import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import handleHospital from "@/services/modules/hospital";

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const cagDischargePdf = () => {
    const { dateOfBarthConvertToAge } = handleHospital();

    const exportToPDF = (company, admissionInfo, dischargeInfo) => {
        const patientData = admissionInfo.patient;

        var doc = {
            pageSize: 'A4',
            pageMargins: [ 25, 25, 25, 25 ],
            pageOrientation: 'landscape',
            content: getContent(patientData, admissionInfo, dischargeInfo, company),
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'CAG Discharge Report',
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (patientData, admissionInfo, dischargeInfo, company) => {
        return [
            {
              absolutePosition: { x: 300, y: 500 },
              table: {
                body: [
                  [ { text: 'কর্তব্যরত চিকিৎসকের সাক্ষর' }],
                  [ { text: 'Rank: ' }],
                  [ { text: 'Date: ' }]
                ]
              },
              layout: 'noBorders',
            },
            {
                margin: [0, 0, 0, 0],
                table: {
                    widths: ['50%', '50%'],
                    body: [
                      // Row 1
                      [
                        getUpperRight(dischargeInfo.service.doctor_order),
                        getUpperLeft(patientData, admissionInfo, dischargeInfo, company),
                      ],
                      // Row 2
                      [
                        getLowerLeft(dischargeInfo.service.doctor_order),
                        getLowerRight(dischargeInfo.service.doctor_order),
                      ]
                    ]
                },
                layout: 'noBorders',
            },
        ]     
    }

    const getUpperLeft = (patientData, admissionInfo, dischargeInfo, company) => {

        return {
          table: {
            widths: ['*'],
            body: [
                [
                  {
                    table: {
                      widths: ['*'],
                      body: [
                        [
                          {
                            image: company.cover_photo64,
                            width: 400,
                            alignment: 'center',
                          }
                        ]
                      ],
                    },
                    layout: 'noBorders'
                  }
                ],
                [
                  {
                    columns: [
                      { width: '*', text: '' },
                      {
                          width: 'auto',
                              table: {
                              body: [
                                [
                                  { text: "DISCHARGE CERTIFICATE", style: "tableHeader" }
                                ]
                              ],
                              alignment: "center"
                            }
                      },
                      { width: '*', text: '' },
                    ],
                    margin: [0, 0, 0, 10]
                  }
                ],
                [
                  {
                    table: {
                      widths: ['40%', '20%', '20%'],
                      body: [
                        [
                          { text: 'Name', bold: true },
                          { text: 'Age', bold: true },
                          { text: 'Sex', bold: true }
                        ],
                        [
                          { text: patientData.full_name || '' },
                          { text: patientData.birthday ? `${calculateAge(patientData.birthday)}` : '' },
                          { text: patientData.gender || '' }
                        ]
                      ]
                    },
                    layout: 'noBorders'
                  }
                ],
                [
                  {
                    table: {
                      widths: ['100%'],
                      body: [
                        [
                          { text: 'Ward / Bed Details:', bold: true }
                        ],
                        [
                          { text: admissionInfo.ward_bed_details || '' }
                        ]
                      ]
                    },
                    layout: 'noBorders'
                  }
                ],
                [
                  {
                    table: {
                      widths: ['50%', '50%'],
                      body: [
                        [
                          { text: 'Date of Admission', bold: true },
                          { text: 'Date of Discharge', bold: true }
                        ],
                        [
                          { text: admissionInfo.admission_date },
                          { text: dischargeInfo.service.delivery_date_time }
                        ]
                      ]
                    },
                    layout: 'noBorders'
                  }
                ],
                [
                  getDiagnosisNote(admissionInfo.notes, dischargeInfo.dischargeNotes)
                ],
                [
                  { text: 'NAME OF UNIT CHIEF', bold: true, margin: [0, 10, 0, 2] }
                ],
                [
                  { text: admissionInfo.human_resource && admissionInfo.human_resource.name }
                ],
                [
                  { text: 'ASISTANT PROFESSOR', bold: true, margin: [0, 10, 0, 2] }
                ],
                [
                  { text: admissionInfo.admitted_by_user.full_name || '' }
                ]
            ]
          },
          layout: 'noBorders',
          margin: [10, 0, 10, 10]
        };
    };

    const getLowerLeft = (doctorOrder) => {
        const header = {
            text: 'INVESTIGATIONS',
            alignment: 'left',
            bold: true,
            fontSize: 12,
            margin: [0, 5, 10, 5],
            pageBreak: 'before'
        };

        if (! doctorOrder) return [header];

        const body = doctorOrder.investigation_orders.map(item => [
          { text: item.product.name + ': ' + (item.remarks ? item.remarks : '') || '', margin: [0, 4, 0, 4] },
        ]);

        const table = {
            table: {
                body
            },
            layout: 'noBorders'
        }

        return [header, table]
    }

    const getUpperRight = (doctorOrder) => {
        const header = {
            text: 'উপদেশ',
            alignment: 'left',
            fontSize: 14,
            margin: [0, 5, 0, 5],
        };

        if (!doctorOrder || !Array.isArray(doctorOrder.notes) || doctorOrder.notes.length === 0) {
            return [header];
        }
    
        const notesList = doctorOrder.notes.flatMap(noteObj => {
            if (Array.isArray(noteObj.note)) {
                return noteObj.note.map(n => `• ${n}`);
            }
            return [];
        });
    
        const noteTextBlock = {
            margin: [0, 0, 0, 5],
            fontSize: 12,
            lineHeight: 1.3,
            ul: notesList
        };
    
        return [header, noteTextBlock];
    }

    const getLowerRight = (doctorOrder) => {
        const header = {
            text: 'ছুটিকালীন চিকিৎসা (TREATMENT ON DISCHARGE)',
            alignment: 'left',
            fontSize: 14,
            margin: [10, 5, 10, 5],
            pageBreak: 'before'
        };

        const subHeader = {
            text: 'Rx',
            alignment: 'left',
            fontSize: 12,
            margin: [15, 5, 0, 5],
        }

        if (!doctorOrder || !Array.isArray(doctorOrder.medicine_orders) || doctorOrder.medicine_orders.length === 0) {
            return [header, subHeader];
        }

        const medicineItems = doctorOrder.medicine_orders.map((item, index) => {
            const line1 = {
                text: `${index + 1}. ${item.product.name || '—'}`,
                bold: true,
                margin: [15, 3, 0, 1],
            };

            const line2 = {
                text: `${item.dose || ''} \t ${item.unit || ''} \t ${item.remarks || ''} \t ${item.duration || ''}`,
                fontSize: 10,
                margin: [17, 0, 0, 2],
            };

            return [line1, line2];
        }).flat();

        return [
            header,
            subHeader,
            ...medicineItems
        ];
    }

    const getDiagnosisNote = (notes = [], dischargeNotes = {}) => {
      const title = {
        text: 'DIAGNOSIS',
        bold: true,
        margin: [0, 10, 0, 5],
        fontSize: 12
      };

      const noteNameMap = dischargeNotes.find(i => i.value === 'diagnosis').name || {};

      const filteredNotes = notes.filter(note =>
        noteNameMap[note.type]
      );
    
      if (filteredNotes.length === 0) return [title];
    
      const body = filteredNotes.map(note => {
        const label = noteNameMap[note.type];
        let noteText = ''
        if(note.note.length > 0) {
          noteText = note.note.join(', ');
        }

        return {
          text: `${label}: ${noteText}`,
          margin: [0, 2],
          fontSize: 10
        };
      });
    
      return [title, ...body];
    };

    const calculateAge = (birthday) => {
        const { year } = dateOfBarthConvertToAge(birthday)
        return `${year} Yr` 
    };

    return {
        exportToPDF
    }
}

export default cagDischargePdf;